import { MemberModel } from './../../model/member.model';
import { BreakModel } from './../../model/break.model';
import { CallModel } from './../../model/call.model';
import { Injectable } from "@angular/core";

@Injectable()
export class OperatorService {


    /**
     * å¤æ¥
     * @param model 
     */
    dial(model: CallModel) {

    }

    /**
     * ææ·
     * @param model 
     */
    haungup(model: CallModel) {

    }

    /**
     * æ¥è½
     * @param model 
     */
    answer(model: CallModel) {

    }

    /**
     * ä¼æ¯
     * @param model 
     */
    breakon(model : BreakModel) {

    }

    /**
     * ä¼æ¯çµæ
     * @param model 
     */
    breakoff(model : MemberModel) {

    }

    /**
     * ç·ä¸ä½æ¥­
     * @param model 
     */
    workon(model : BreakModel) {

    }

    /**
     * ç·ä¸ä½æ¥­çµæ
     * @param model 
     */
    workoff(model : MemberModel) {

    }


}
